<template>
    <div>
		<component v-bind:is="this.firstUpperCaseGameName"></component>
    </div>
</template>

<script>
import Cleopatra from './paytable/Cleopatra';

export default {
    data() {
        return {
            gameName: Config.game_name.toLowerCase()
        }
    },
    components: {Cleopatra},
    computed: {
        firstUpperCaseGameName() {
            return this.gameName.charAt(0).toUpperCase() + this.gameName.slice(1);
        }
    }
}
</script>